module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('time-line', {
    attrs: {
      "target": _vm.user.email
    }
  }), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "header": _vm.$t('userInfoCardDevicesHeaderText', {
        devicesCount: _vm.devicesCount
      }),
      "data-qa": "Content-UserInfo-Card-Devices"
    }
  }, [(_vm.devicesCount > 0) ? _c('div', _vm._l((_vm.devices), function(device, index) {
    return _c('p', {
      key: ((device.id) + "-" + index)
    }, [_c('router-link', {
      attrs: {
        "data-qa": ("Content-UserInfo-DeviceLink-" + (device.id)),
        "to": ("/device/" + (device.id)),
        "replace": ""
      }
    }, [_vm._v(_vm._s(device.id))])], 1)
  })) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('userInfoCardDevicesEmptyText')))])])]), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "header": _vm.$t('userInfoCardGroupsHeaderText', {
        groupsCount: _vm.groupsCount
      }),
      "data-qa": "Content-UserInfo-Card-Groups"
    }
  }, [(_vm.groupsCount > 0) ? _c('div', _vm._l((_vm.groups), function(group, index) {
    return _c('p', {
      key: ((group.name) + "-" + index)
    }, [_vm._v(_vm._s(_vm.getGroupName(group)))])
  })) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('userInfoCardGroupEmptyText')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8000a62c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo/UserInfo.vue
// module id = 977
// module chunks = 3